class TeamChannelMapping {
  id;

  active;

  thirdPartyTeamId;

  thirdPartyTeamName;

  thirdPartyType;

  teamId;

  teamName;

  constructor(json) {
    this.fromJSON(json);
  }

  fromJSON(res = {}) {
    this.id = res.uuid;
    this.active = res.active;
    this.thirdPartyTeamId = res.thirdPartyTeamId;
    this.thirdPartyTeamName = res.thirdPartyTeamName;
    this.thirdPartyType = res.thirdPartyType;
    this.teamId = res.team ? res.team.uuid : null;
    this.teamName = res.team ? res.team.name : null;
  }
}

export default TeamChannelMapping;
